import { render, staticRenderFns } from "./SettingsSpecific.vue?vue&type=template&id=f44ea9b2"
import script from "./SettingsSpecific.vue?vue&type=script&lang=ts"
export * from "./SettingsSpecific.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports